import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ComponentTierName } from '@/constants/enums';
import { getDynamicComponent } from '@/constants/componentsMap';
import { useStores } from '@/hooks/use-stores';

const LeakageReportPage = observer(() => {
  const { t } = useTranslation();
  const { stationStore } = useStores();

  const currentTier = stationStore?.stationTier;
  const Leakage = getDynamicComponent(ComponentTierName.Leakage, currentTier);
  return (
    <Container>
      <Leakage
        className="leakage-card-item"
        description={t('leakageReportDescription')}
        activeTab="overview"
        animation={false}
        reportView={true}
      />
      <Leakage className="leakage-card-item" title={null} activeTab="measurement-segmentation" animation={false} />
    </Container>
  );
});

const Container = styled.div`
  .leakage-card-wrapper {
    width: 620px;
    margin-left: auto;
    margin-right: auto;
    margin-top: ${({ theme: { token } }) => token.marginMD}px;
  }
`;

export default LeakageReportPage;
